import { render, staticRenderFns } from "./AdminZones.vue?vue&type=template&id=53a60025&scoped=true"
import script from "./AdminZones.vue?vue&type=script&lang=js"
export * from "./AdminZones.vue?vue&type=script&lang=js"
import style0 from "./AdminZones.vue?vue&type=style&index=0&id=53a60025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a60025",
  null
  
)

export default component.exports